(function () {
  const HIDE_DELAY_MS = 4000;

  function init(indicator) {
    if (indicator.dataset.scrollIndicatorInit === 'true') return;
    indicator.dataset.scrollIndicatorInit = 'true';

    const gallery = indicator.closest('product-gallery');
    const viewer = gallery?.querySelector('[data-gallery-viewer]');

    let hidden = false;
    let timer;

    const cleanup = () => {
      window.removeEventListener('scroll', hide);
      viewer?.removeEventListener('scroll', hide);
      viewer?.removeEventListener('wheel', hide);
      viewer?.removeEventListener('touchmove', hide);
      clearTimeout(timer);
    };

    function hide() {
      if (hidden) return;
      hidden = true;
      indicator.classList.add('is-hidden');
      cleanup();
      setTimeout(() => indicator.remove(), 600);
    }

    window.addEventListener('scroll', hide, { passive: true });
    viewer?.addEventListener('scroll', hide, { passive: true });
    viewer?.addEventListener('wheel', hide, { passive: true });
    viewer?.addEventListener('touchmove', hide, { passive: true });

    timer = setTimeout(hide, HIDE_DELAY_MS);
  }

  function bootstrap() {
    document.querySelectorAll('[data-scroll-indicator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
